import { Box } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
import { useStyles } from "./styles";
const BottomTenantTabs = ({ index, setIndex }) => {
  const styles = useStyles();
  const navigation = useNavigate();
  return (
    <>
      <Box className={styles.navigation}>
        <Box
          className={styles.navView}
          onClick={() => {
            setIndex(0);
            navigation("/tenant-account/");
          }}
        >
          {index === 0 ? <div className={styles.indicator} /> : null}
          <img
            src={
              index === 0
                ? require("../../../assets/dashboard.png")
                : require("../../../assets/inactive_dashboard.png")
            }
            alt=""
            className={styles.icon}
          />
          <div className={index === 0 ? styles.activenavText : styles.navText}>
            Dashboard
          </div>
        </Box>
        <Box
          className={styles.navView}
          onClick={() => {
            setIndex(1);
            navigation("/tenant-account/accounting");
          }}
        >
          {index === 1 ? <div className={styles.indicator} /> : null}
          <img
            src={
              index !== 1
                ? require("../../../assets/profit.png")
                : require("../../../assets/inactive_profit.png")
            }
            alt=""
            className={styles.icon}
          />
          <div className={index === 1 ? styles.activenavText : styles.navText}>
            Accounting
          </div>
        </Box>
        <Box
          className={styles.navView}
          onClick={() => {
            setIndex(2);
            navigation("/tenant-account/contacts");
          }}
        >
          {index === 2 ? <div className={styles.indicator} /> : null}
          <img
            src={
              index !== 2
                ? require("../../../assets/contactF.png")
                : require("../../../assets/contactFY.png")
            }
            alt=""
            className={styles.icon}
          />
          <div className={index === 2 ? styles.activenavText : styles.navText}>
            Contacts
          </div>
        </Box>
        <Box
          className={styles.navView}
          onClick={() => {
            setIndex(3);
            navigation("/tenant-account/maintenance");
          }}
        >
          {index === 3 ? <div className={styles.indicator} /> : null}
          <img
            src={
              index !== 3
                ? require("../../../assets/maintenance.png")
                : require("../../../assets/activeMaintanence.png")
            }
            alt=""
            className={styles.icon}
          />
          <div className={index === 3 ? styles.activenavText : styles.navText}>
            Maintenance
          </div>
        </Box>
      </Box>
    </>
  );
};

export default BottomTenantTabs;
